import { render, staticRenderFns } from "./soroteca-localizar.vue?vue&type=template&id=0b4eadba&scoped=true&"
import script from "./soroteca-localizar.vue?vue&type=script&lang=js&"
export * from "./soroteca-localizar.vue?vue&type=script&lang=js&"
import style0 from "./soroteca-localizar.vue?vue&type=style&index=0&id=0b4eadba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4eadba",
  null
  
)

export default component.exports